export default "__VITE_ASSET__B4HZBm15__"